import { useCallback } from "react";
import { useNavigate } from "react-router";
import { useOpenWindow } from "@/components/ui/os-layout";
import { guardiansConversationUrl } from "@/navigation/apps/guardiansLocation";
import { openGuardiansConversation, type OpenGuardiansConversationInput } from "./openGuardiansConversation";

/** Open mission/task conversation in the aniOS utility window, or navigate in classic layout. */
export function useOpenGuardiansConversation(): (input: OpenGuardiansConversationInput) => void {
  const openWindow = useOpenWindow();
  const navigate = useNavigate();

  return useCallback(
    (input: OpenGuardiansConversationInput) => {
      if (openGuardiansConversation(input, openWindow)) return;

      const url = guardiansConversationUrl({
        missionId: input.missionId,
        taskId: input.taskId,
        focus: input.focus,
      });
      const path = url.replace(window.location.origin, "");
      navigate(path);
    },
    [navigate, openWindow]
  );
}
